import { FILTER_TYPE_MIN_MAX, IMAGE, VIDEO } from '../../constants/constants';
import { userNotify } from '../../modules/components/Toasts/ToastAdd';
import { pageFilters } from '../../modules/new-search-page/searchPageFilters';
import callApi from '../../util/apiCaller';
import { uploadFile } from '../../util/apiVenueCaller';
import { sortTheList } from '../../util/utility';
import callVendorApi from '../../util/vendorApiCaller';
import { callSearchVendors } from '../../util/vmSearch';
import { setPageNotFound } from './AppActions';

export const SET_REVIEW_MODAL_STATE = 'SET_REVIEW_MODAL_STATE';
export const ADDING_USER_COMMENT = 'ADDING_USER_COMMENT';
export const FETCHED_PHOTOGRAPHER_DATA = 'FETCHED_PHOTOGRAPHER_DATA';
export const FETCHED_NEW_PHOTOGRAPHER_REVIEW = 'FETCHED_NEW_PHOTOGRAPHER_REVIEW';
export const FETCHED_PHOTOGRAPHER_REVIEW_LIST = 'FETCHED_PHOTOGRAPHER_REVIEW_LIST';
export const USER_HAS_PHOTGRAPHER_REVIEW = 'USER_HAS_PHOTGRAPHER_REVIEW';
export const CLEAR_PHOTOGRAPHER_REVIEW_LIST = 'CLEAR_PHOTOGRAPHER_REVIEW_LIST';
export const SET_PHOTOGRAPHER_REVIEW_COUNT = 'SET_PHOTOGRAPHER_REVIEW_COUNT';
export const FETCH_SEARCH_PAGE_VENDOR_KEY = 'FETCH_SEARCH_PAGE_VENDOR_KEY';
export const VENDORS_SET_FILTERS = 'VENDORS_SET_FILTERS';
export const VENDOR_IS_OPEN_GALLERY_FOR_SEARCHPAGE = "VENDOR_IS_OPEN_GALLERY_FOR_SEARCHPAGE"
export const VENDOR_UPDATING_VENUE_SEARCH_VALIDATORS = "VENDOR_UPDATING_VENUE_SEARCH_VALIDATORS"
export const VENDORS_FETCHING_VENUES = "VENDORS_FETCHING_VENUES"
export const LOAD_VENDOR_LIST = "LOAD_VENDOR_LIST"
export const FETCH_VENDOR_SEARCH_PAGE_ALL_ASSET = "FETCH_VENDOR_SEARCH_PAGE_ALL_ASSET"
export const VENDORS_SET_APPLIED_FILTERS = "VENDORS_SET_APPLIED_FILTERS"
export const VENDORS_SET_MIN_MAX_FILTER_ITEM = "VENDORS_SET_MIN_MAX_FILTER_ITEM"
export const VENDORS_SET_PAGE_FILTERS = "VENDORS_SET_PAGE_FILTERS" 
export const SET_VENDOR_FILTER = "SET_VENDOR_FILTER" 
export const SET_VENDOR_FILTER_ITEM = "SET_VENDOR_FILTER_ITEM"
export const SET_SELECTED_VENDOR = "SET_SELECTED_VENDOR"
export const SET_SORT_VENDOR_FILTERS = "SET_SORT_VENDOR_FILTERS"
export const FETCHED_VENDOR_REVIEW_LIST ="FETCHED_VENDOR_REVIEW_LIST"
export const CLEAR_VENDOR_REVIEW_LIST = "CLEAR_VENDOR_REVIEW_LIST"
export const USER_HAS_VENDOR_REVIEW ="USER_HAS_VENDOR_REVIEW"
export const FETCHED_NEW_VENDOR_REVIEW ="FETCHED_NEW_VENDOR_REVIEW" 
export const SET_VENDOR_SUCCESS_MODAL_STATE ="SET_VENDOR_SUCCESS_MODAL_STATE" 





export function setPhotographerVendorData(data) {
    return {
        type: FETCHED_PHOTOGRAPHER_DATA,
        photographer: data.photographer,
        reviews: data.photographer_reviews,
        packages: data.photographer_packages,
        faqs: data.photographer_faqs,
        assets: data.photographer_assets,
        expertReviews: data.photographer_expert_review,
    };
}

export function fetchPhotographerVendor(url) {
    return async (dispatch) => {
        const res = await callVendorApi(`photographer/${url}/page`);
        if (res.status === 'Success') {
            dispatch(setPhotographerVendorData(res.data));
        }
    };
}

export function setSuccessModalState(val) {
    return {
        type: SET_VENDOR_SUCCESS_MODAL_STATE,
        isSuccessModalVisible: val,
    };
}

export function setReviewModalState(val) {
    return {
        type: SET_REVIEW_MODAL_STATE,
        isReviewModalVisible: val,
    };
}

export function showLoaderWhileAddingVendorReview(val) {
    return {
        type: ADDING_USER_COMMENT,
        isAddingUserComent: val,
    };
}

export function fetchNewPhotographerReview(data) {
    return {
        type: FETCHED_NEW_PHOTOGRAPHER_REVIEW,
        newPhotographReview: data,
    };
}
export function fetchNewVendorReview(data) {
    return {
        type: FETCHED_NEW_VENDOR_REVIEW,
        newVendorReview: data,
    };
}

export function fetchPhotographerReviewList(id, filters) {
    return async (dispatch) => {
        const res = await callVendorApi(`photographer-review/photographer/${id}/list`, 'POST', filters)
        if (res.status === "Success") {
        dispatch({
                type: FETCHED_PHOTOGRAPHER_REVIEW_LIST,
                photographerReviewList: res.data.photographer_reviewList,
                photographerReviewCount: res.data.photographer_reviewCount
            })
        }
    }
}


export function fetchVendorsReviewList(modelname,routename,id, filters) {
    return async (dispatch) => {
        const res = await callVendorApi(`${routename}-review/${routename}/${id}/list`, 'POST', filters)
        if (res.status === "Success") {
        dispatch({
                type: FETCHED_VENDOR_REVIEW_LIST,
                vendorReviewList: res.data[`${modelname}_reviewList`],
                vendorReviewCount: res.data[`${modelname}_reviewCount`]
            })
        }
    }
}





export function addNewPhotographerReview(post, url, id, filters) {
    return async (dispatch) => {
        dispatch({
            type: CLEAR_PHOTOGRAPHER_REVIEW_LIST,
            payload: []
        })
        dispatch(showLoaderWhileAddingVendorReview(true));
        const res = await callVendorApi(`photographer-review/photographer/${id}/add`, 'POST', {
            ...post,
        });
        
        if (res.status === 'Success') {
            userNotify('Your review has been added', 'success');
            dispatch(showLoaderWhileAddingVendorReview(false));
            vendorPageDataDecache(url);
            dispatch(fetchNewPhotographerReview(res.data.photographer_review));
            dispatch(fetchPhotographerReviewList(id, filters))
        } else {
            dispatch(showLoaderWhileAddingVendorReview(false));
        }
    };
}
export function addNewVendorReview(modelname,routename,post, url, id, filters) {
    return async (dispatch) => {
        dispatch({
            type: CLEAR_VENDOR_REVIEW_LIST,
            payload: []
        })
        dispatch(showLoaderWhileAddingVendorReview(true));
        const res = await callVendorApi(`${routename}-review/${routename}/${id}/add`, 'POST', {
            [`${modelname}_review`]: post,
        });
        
        if (res.status === 'Success') {
            userNotify('Your review has been added', 'success');
            dispatch(setSuccessModalState(true))
            dispatch(showLoaderWhileAddingVendorReview(false));
            vendorPageDataDecache(url,routename);
            dispatch(fetchVendorsReviewList(modelname,routename,id, filters))
        } else {
            dispatch(showLoaderWhileAddingVendorReview(false));
        }
    };
}

export function editUserPhotographerReview(id, comment, vendorid, filters, url, context){
    return async (dispatch) => {
        dispatch({
            type: CLEAR_PHOTOGRAPHER_REVIEW_LIST,
            payload: []
        })
        const res = await callVendorApi(`photographer-review/${id}/update-info`, 'POST', {
            ...comment
        })  
        if(res.status === "Success"){
            userNotify(`Your review has been ${context} `, 'success');
            dispatch(fetchPhotographerReviewList(vendorid, filters))
            vendorPageDataDecache(url)
        }
    }
}
export function editUserVendorReview(modelname,routename,id, comment, vendorid, filters, url, context){
    return async (dispatch) => {
        dispatch({
            type: CLEAR_VENDOR_REVIEW_LIST,
            payload: []
        })
        const res = await callVendorApi(`${routename}-review/${id}/update-info`, 'POST', {
            ...comment
        })  
        if(res.status === "Success"){
            userNotify(`Your review has been ${context} `, 'success');
            dispatch(setSuccessModalState(true))
            dispatch(fetchVendorsReviewList(modelname,routename,vendorid, filters))
            vendorPageDataDecache(url,routename)
        }
    }
}

export async function vendorPageDataDecache(url,routename="photographer") {
    const res = await callVendorApi(`${routename}/${url}/page/de-cache`);
    return res;
}

export function setUserPhotographerReviewState(review, val){
   return (dispatch => {
       dispatch({
           type: USER_HAS_PHOTGRAPHER_REVIEW,
           userPhotographerReview: review,
           userHasPhotographerReview: val
       })
   })
}
export function setUserVendorReviewState(review, val){
   return (dispatch => {
       dispatch({
           type: USER_HAS_VENDOR_REVIEW,
           userVendorReview: review,
           userHasVendorReview: val
       })
   })
}

export function uploadMedia(file, filePath) {
    return async (dispatch) => {
        userNotify("Uploading Media", "success")
        let data = new FormData();
        data.append('file', file);

        const res = await uploadFile(`v1/assets/upload?fileName=${filePath}`, 'post', data);
        if (res.status === 'Success') {
            userNotify("Media Uploaded Successfully", "success")
        } else {
            userNotify("Error, File size is too large", 'error');
        }
    };
}

export function fetchSearchPageVendorTypeKey(key, source){
    return (dispatch => dispatch({
        type: FETCH_SEARCH_PAGE_VENDOR_KEY,
        searchPageVendorKey: key,
        vendorEventBtnSource: source
    }))
}


export function loadFilters(data, searchFilterList) { 
    //needed
    let venueSearchParams = [];
    let venueSearchFilters = [];
    const DYNAMIC_LIST = ['servicetypes', 'locations',"services_speciality",,"siders_options","other_services_offered","services_availabile_at"];
    const filteredList = data?.filters?.filter((f) => DYNAMIC_LIST.includes(f.keyName));
    if (filteredList?.length > 0) {
        venueSearchFilters = [...searchFilterList, ...filteredList]
        venueSearchFilters.map((venueSearch) => {
            if (venueSearch.filterType === FILTER_TYPE_MIN_MAX) {
                venueSearchParams.push(
                    {paramName: venueSearch.minQueryParamName},
                    {paramName: venueSearch.maxQueryParamName}
                );
            } else {
                venueSearchParams.push({paramName: venueSearch.queryParamName});
            }
            if (venueSearch.keyName === 'servicetypes') venueSearch.mobileSortOrder = 1;
            if (venueSearch.keyName === 'locations') venueSearch.mobileSortOrder = 2;
            if (venueSearch.keyName === 'budget') venueSearch.mobileSortOrder = 3;
            if (venueSearch.keyName === 'reviewcount') venueSearch.mobileSortOrder = 4;
            if (venueSearch.keyName === 'rating') venueSearch.mobileSortOrder = 5;
            if (venueSearch.keyName === 'experience') venueSearch.mobileSortOrder = 6;
            if (venueSearch.keyName === 'services_speciality') venueSearch.mobileSortOrder = 7;
            if (venueSearch.keyName === 'siders_options') venueSearch.mobileSortOrder = 8;
            if (venueSearch.keyName === 'services_availabile_at') venueSearch.mobileSortOrder = 9;
            if (venueSearch.keyName === 'other_services_offered') venueSearch.mobileSortOrder = 10;
            if (venueSearch.keyName === 'sort') venueSearch.mobileSortOrder = 11;
            if (venueSearch?.params?.length > 0) {
                if (venueSearch?.keyName === 'servicetypes') {
                    venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                }
                if (venueSearch?.keyName === 'locations') {
                    venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                } else {
                    venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                    // venueSearch?.params.sort((a, b) => sortTheList(a, b, 'label', 'asc'));
                }
                if (venueSearch?.keyName === 'locations') {
                    venueSearch.displayName = 'Location';
                }
            } else if (venueSearch?.maxParams?.length > 0) {
                venueSearch?.maxParams.sort((a, b) =>
                    sortTheList(parseInt(a), parseInt(b), 'label', 'asc')
                );
            } else if (venueSearch?.minParams?.length > 0) {
                venueSearch?.minParams.sort((a, b) =>
                    sortTheList(parseInt(a), parseInt(b), 'label', 'asc')
                );
            }
            return venueSearch;
        })
            .sort((a, b) => sortTheList(a, b, 'mobileSortOrder', 'asc'));

    }
    return {
        type: VENDORS_SET_FILTERS, 
        isBaseFiltersLoaded: true,
        vendorSearchFilters: venueSearchFilters,
        sortFilters: data?.sortsets,
        vendorSearchParams: venueSearchParams,
    };
}

export function closeGalleryForVendorImagesGallery(val) {
    return {
        type: VENDOR_IS_OPEN_GALLERY_FOR_SEARCHPAGE,
        isVenueGalleryOpen: val,
        isFetchingVenueAssets: val,
    };
}

export function fetchVendorBaseFilters(routeName,urlslug, query,defaultFilters) {  
    let url = `search/${routeName}/${urlslug}/base-filters`;

    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return async (dispatch) => {
        const baseFilter = await callApi(url, 'GET');
        if (baseFilter?.status === 'Success') {
            dispatch(loadFilters(baseFilter.data, defaultFilters));
        } else {
            dispatch(loadFilters({data: {filters: [], sortsets: []}}, defaultFilters));
        }
    };
    
}

export function fetchVendorsFiltersForList(cityslug, keyword, query) {
    let url = `search/venues`;
    if (keyword && keyword !== '') {
        url = `${url}/${toString(cityslug)}/${keyword}/filter-count`;
    } else {
        url = `${url}/${toString(cityslug)}/venues/filter-count`;
    }
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return (dispatch) => {
        dispatch(showLoadingVenueSearchValidators(true));
        return callApi(url, 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadVenueSearchValidators(res.data));
            } else {
                dispatch(showLoadingVenueSearchValidators(false));
            }
        });
    };
    
}

export function showLoadingVenueSearchValidators(val) { //needed
    return {
        type: VENDOR_UPDATING_VENUE_SEARCH_VALIDATORS, //needed
        isUpdatingVenueSearchValidators: !!val,
    };
}

export function loadVenueSearchValidators(data) {//needed
    return {
        type: VENDOR_UPDATE_VENUE_SEARCH_VALIDATORS, //needed
        isUpdatingVenueSearchValidators: false,
        searchValidators: data.searchValidators,
        totalCount: data.totalCount,
    };
}

export function fetchVendorList(model,route,url, query) {
    let final_url = `v1/search/${route}`; // v1/search/photographer/:url/list?min_price=10000&max_price=500000
    if (url) {
        final_url = `${final_url}/${url}/list`
    }
    if (query && query !== '') {
        final_url = `${final_url}${query}`;
    }
    return async (dispatch) => {
        dispatch(showVenueListLoader());
        const res = await callSearchVendors(url);
        if (res.status === 'Success') {
            if (!isEmpty(res.data.searchlink)) {
                dispatch(loadPVendorsList(model,res.data));
            } else {
                dispatch(setPageNotFound(true));
            }
        }
    };
}

export function showVenueListLoader() { //needed
    return {
        type: VENDORS_FETCHING_VENUES, //needed
        isFetchingVenues: true,
    };
}

export function loadVendorsList(modelName,data) { //needed
    return {
        type: LOAD_VENDOR_LIST,
        isFetchingVenues: false,
        list: data[modelName],
        totalCount: data.totalCount,
        pageNum: data.pageNum,
        searchlink: data.searchlink,
        searchValidators: data.searchValidators,
    };


}

export function openGalleryForVendorImagesGallery(val, vendor, isFetchingVenueAssets) {
    return {
        type: VENDOR_IS_OPEN_GALLERY_FOR_SEARCHPAGE,
        isVenueGalleryOpen: val,
        vendor: vendor,
        isFetchingVenueAssets: isFetchingVenueAssets
    };
}

export function fetchVendorsSearchPageAllAsset(modelName,routeName,vendor) {
    return async (dispatch, getState) => {
        let clickedVenueAssets = getState()?.VendorReducers?.clickedVenueAssets;
        if (
            !clickedVenueAssets?.[vendor?._id]?.images ||
            !(clickedVenueAssets?.[vendor?._id]?.images?.length > 0)
        ) {
            dispatch(openGalleryForVendorImagesGallery(true, vendor, true));
            const res = await callVendorApi(`${routeName}-asset/list`, 'post', {
                filters: {
                    [`${modelName}_id`]: vendor?._id,
                    is_deleted: false
                }
            });
            if (res.status === 'Success') {
                let images = res.data[`${modelName}_assetList`].filter(asset => asset.asset_type === IMAGE)
                let videos = res.data[`${modelName}_assetList`].filter(asset => asset.asset_type === VIDEO)
                dispatch(
                    loadVendorSearchPageAssets(
                        vendor._id,
                        images,
                        videos
                    )
                );
            } else {
                userNotify('Error in fetching media', 'error');
            }
        } else {
            dispatch(openGalleryForVendorImagesGallery(true, vendor, false));
        }
    };
}

export function loadVendorSearchPageAssets(vendor_id, images, assets) { //needed
    return {
        type: FETCH_VENDOR_SEARCH_PAGE_ALL_ASSET, 
        vendor_id: vendor_id,
        images,
        assets,
    };
}

export function setAppliedVendorsFilters(filters, from) { //needed
    return (dispatch) => {
        dispatch({
            type: VENDORS_SET_APPLIED_FILTERS, //needed
            appliedFilters: filters,
        });
    };
}

export function setMinMaxVendorFilterItem(paramName, value) { //needed
    return {
        type: VENDORS_SET_MIN_MAX_FILTER_ITEM, //needed
        paramName: paramName,
        value: value,
    };
}

export function setNewVendorFilters(venueSearchFilters) { //needed
    return {
        type: VENDORS_SET_PAGE_FILTERS, //needed
        vendorSearchFilters: venueSearchFilters,
    };
}

export function setVendorFilterItem(paramName, value) { //needed
    return {
        type: SET_VENDOR_FILTER_ITEM, //needed
        paramName: paramName,
        value: value,
    };
}

export function setVendorFilter(paramName, value, isSelected) { //needed
    return {
        type: SET_VENDOR_FILTER, //needed
        paramName: paramName,
        value: value,
        isSelected: isSelected,
    };
}

export function setSelectedVendor(venue) { //needed
    return {
        type: SET_SELECTED_VENDOR, //needed
        selectedVenue: venue,
    };
}

export function setSortVendorFilters(sortFilters) { //needed
    return {
        type: SET_SORT_VENDOR_FILTERS, //needed
        sortFilters: sortFilters,
    };
}



